export enum TransactionAmountRule {
  NUMBER = 'number',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  MINZERO = 'minzero',
  MAXZERO = 'maxzero',
  PERCENT = 'percent',
}
